import { Col, Row } from 'antd'
import LinkedAccountComponent from '../getBack/LinkedAccountComponent';

interface EarnCashBackProps {
    data: any;
}

const PaymentStatus: React.FC<EarnCashBackProps> = ({ data }) => {
    return (
        <div className="get-back">
            <Row gutter={[10, 16]} style={{
                justifyContent: "space-between"
            }}>
                <Col xs={12} md={12} lg={4}>
                    <div className="text-holder">
                        <h3 className='sub_title'>Redeem With</h3>
                        <h1 className='payment__status__title'>{data?.payment_info?.account_type}</h1>
                    </div>
                </Col>
                <Col xs={12} md={12} lg={4}>
                    <div className="text-holder">
                        <h3 className='sub_title'>ACCOUNT</h3>
                        <LinkedAccountComponent data={data} />
                    </div>
                </Col>
                <Col xs={12} md={12} lg={4}>
                    <div className="text-holder">
                        <h3 className='sub_title'>ACCOUNT</h3>
                        <h1 className='payment__status__title'>${data?.payment_info?.amount?.toFixed(2)}</h1>
                    </div>
                </Col>
                 <Col xs={12} md={12} lg={4}>
                    <div className="text-holder">
                        <h3 className='sub_title'>PAYMENT</h3>
                        <h1 className='payment__status__title'>${data?.payment_info?.amount?.toFixed(2)}</h1>
                    </div>
                </Col>
                <Col xs={12} md={12} lg={4}>
                    <div className="text-holder">
                        <h3 className='sub_title'>Status</h3>
                        <h1 className='payment__status__title'>{data?.payment_info?.status || '-'}</h1>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default PaymentStatus